<template>
  <v-card>
    <v-toolbar flat light color="white" v-if="$vuetify.breakpoint.smAndDown">
      <v-toolbar-title>{{ $t('ppc-header') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn light icon @click="$emit('close')">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
    <v-container class="pb-0" v-if="$vuetify.breakpoint.mdAndUp">
      <v-row justify="end">
        <v-col class="shrink">
          <v-btn color="color-grey" depressed right text small @click="$emit('close')">
            <v-icon class="mr-3">fa-times</v-icon>
            <span>{{ $t('close') }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pt-0 pb-16" fluid>
      <v-row justify="center">
        <v-col class="shrink">
          <v-icon :size="$vuetify.breakpoint.smAndDown ? 100 : 150" color="color-new-title-green">
            far fa-check-circle
          </v-icon>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="$vuetify.breakpoint.mdAndUp">
        <v-col class="text-center">
          <h1 class="mt-4 text-h1">{{ $t('ppc-header') }}</h1>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="9">
          <v-card outlined class="blue-outline">
            <v-container class="pa-6">
              <v-row align="center">
                <v-col class="shrink">
                  <v-icon x-large>fas fa-info-circle</v-icon>
                </v-col>
                <v-col>
                  <p>{{ $t('ppc-text-1') }}</p>
                  <p>{{ $t('ppc-text-2') }}{{nextInstallmentAmount}}{{ $t('ppc-text-3') }}{{nextInstallmentDuedate | formatDate }}{{ $t('ppc-text-4') }}</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" class="text-center">
        <v-col cols="12" sm="10">
          <span>{{ $t('ppc-text-5') }}</span>
        </v-col>
      </v-row>
      <v-row justify="center" class="text-center">
        <shared-customer-feedback :orderNr="debtNr" :type="3" @close="$emit('close')"></shared-customer-feedback>
      </v-row>
      <v-row justify="center">
        <v-btn tile outlined dark color="color-new-link-blue" class="wide-button" @click="$emit('close')">
          <span>{{ $t('close') }}</span>
        </v-btn>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    computed: {
      paymentPlan() {
        return this.$store.getters.latestPaymentPlan
      },
      debtNr() {
        if (this.paymentPlan !== null) {
          return this.paymentPlan.debts[0].nr
        } else {
          return null
        }
      },
      nextInstallmentAmount() {
        if (this.paymentPlan !== null && this.paymentPlan.nextInstallment !== null) {
          return this.paymentPlan.nextInstallment.eur
        } else {
          return null
        }
      },
      nextInstallmentDuedate() {
        if (this.paymentPlan !== null && this.paymentPlan.nextInstallment !== null) {
          return this.paymentPlan.nextInstallment.duedate
        } else {
          return null
        }
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "ppc-header": "Maksusuunnitelma luotu",
  "ppc-text-1": "Kiitos! Maksusuunnitelmasi on nyt aktiivinen",
  "ppc-text-2": "Maksusuunnitelmasi ensimmäinen erä (",
  "ppc-text-3": " €) tulee maksaa ",
  "ppc-text-4": " mennessä",
  "ppc-text-5": "Mikäli saman toimeksiantajan uusia laskuja tulee myöhemmin perintään, maksusuunnitelma voidaan purkaa"
  },
  "se": {
  "ppc-header": "Betalningsplan skapad",
  "ppc-text-1": "Tack! Din betalningsplan är nu aktiv",
  "ppc-text-2": "Första raten i din betalningsplan (",
  "ppc-text-3": " €) måste betalas senast ",
  "ppc-text-4": "",
  "ppc-text-5": "Ifall mera fakturor kommer till indrivning från den samma uppdragsgivare, betalningsplan kan sägs upp"
  },
  "en": {
  "ppc-header": "Payment plan created",
  "ppc-text-1": "Thank you! Your payment plan is now active",
  "ppc-text-2": "The first installment of your payment plan (",
  "ppc-text-3": " €) is due in ",
  "ppc-text-4": "",
  "ppc-text-5": "If new invoices from the same creditor will end up in collection, the payment plan may be cancelled"
  }
  }
</i18n>
